import React, { useContext } from 'react';
import { Modal, Typography, Button, Table, Upload } from 'antd';
import locale from 'antd/es/locale/pt_BR';
import {
    CloudUploadOutlined,
    InboxOutlined,
    CloseOutlined
} from '@ant-design/icons';

import { Loading } from '../../../../components/Loading';
import { useAbaImportacoes } from './useAbaCongelamentoEmLote';
import { GlobalContext } from '../../../../contexts/globalContext';

const { Text } = Typography;

export const AbaImportantes: React.FC = () => {

    const {
        loadingPage,
        setVisibleModal,
        clickBtnSubmitUploadArquivo,
        arquivoObjeto,
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        visibleModal,
        clickCancelModal,
        loading,
        dummyRequest,
        beforeUpload,
        handleChange,
        setArquivoObjeto,
    } = useAbaImportacoes();

    const { theme } = useContext(GlobalContext);

    return (
        <>
            <Loading
                loading={loadingPage}
            >
                <div
                    style={{
                        display: 'flex',
                        // justifyContent: 'flex-end',
                        // justifyContent: 'flex-end'
                        marginBottom: 15
                    }}
                >
                    <Button
                        type="primary"
                        className="botaoVerdeBaixarTodas"
                        style={{ margin: 2 }}
                        // disabled={!hasSelectedAdd}
                        onClick={() => { setVisibleModal(true) }}
                    >
                        Upload Arquivo<CloudUploadOutlined />
                    </Button>
                </div>
                <Table
                    style={{
                        // marginTop: 50
                    }}
                    className='marginTopTables'
                    rowKey={(record) => record.id}
                    // loading={loadingTable}
                    // onRow={(record, rowIndex) => {
                    //     return {
                    //         onClick: event => { onclickTable(record, rowIndex) }, // click row
                    //         onDoubleClick: event => { }, // double click row
                    //         onContextMenu: event => { }, // right button click row
                    //         onMouseEnter: event => { }, // mouse enter row
                    //         onMouseLeave: event => { }, // mouse leave row
                    //     };
                    // }}
                    // rowSelection={rowSelection}
                    columns={columns} dataSource={dadosTabelaState}
                    scroll={{ x: 650 }}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource
                        }
                    }
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5
                                }}
                            >
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        dadosTabelaState.length :
                                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: 'end'
                                }}
                            >
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        dadosTabelaState.length :
                                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    size="small"
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: false,
                        defaultPageSize: 100,
                        // position: ['topRight', 'bottomRight'],
                        position: [],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    locale={locale.Table}
                />
            </Loading>
            <Modal
                title="Upload Arquivo"
                visible={visibleModal}
                onOk={() => clickBtnSubmitUploadArquivo(arquivoObjeto)}
                onCancel={() => clickCancelModal()}
                style={{
                    top: 20
                }}
                // className="modalDadasLimite_kaevdkfaed"
                footer={[
                    <Button
                        key="back"
                        onClick={clickCancelModal}
                        loading={loading}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => {
                            clickBtnSubmitUploadArquivo(arquivoObjeto)
                        }}
                        disabled={!arquivoObjeto}
                    >
                        Salvar
                    </Button>
                ]}
                key="modalUploadArquivos"
            >
                <Loading
                    loading={loading}
                >
                    <Upload.Dragger
                        // name="file"
                        // listType="picture-card"

                        // className="avatar-uploader"
                        style={{
                            // width: 400,
                            // height: 128
                        }}
                        // multiple={true}
                        // fileList={arquivoObjeto}
                        showUploadList={false}

                        customRequest={dummyRequest}
                        // action={() => {
                        //     return new Promise((resolve, reject) => {
                        //         reject('done');
                        //     })
                        // }}
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                    // onPreview={() => {}}
                    // onRemove={(file) => {console.log(file); return (true)}}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text" style={{ color: 'red' }}>Envio somente de arquivos .XLSX</p>
                        <p className="ant-upload-text">Clique ou arraste o arquivo para esta área para fazer upload</p>
                    </Upload.Dragger>
                    {arquivoObjeto &&
                        <div style={{
                            marginTop: 8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <Text>
                                {arquivoObjeto?.file?.name}
                            </Text>
                            <Button
                                type='text'
                                danger
                                style={{ margin: 0, padding: 0 }}
                                icon={<CloseOutlined />}
                                onClick={() => {
                                    setArquivoObjeto(null)
                                }}
                            />
                        </div>
                    }
                </Loading>
            </Modal>
        </>
    );
}
